import { render, staticRenderFns } from "./time-ago.vue?vue&type=template&id=d92a1b30&scoped=true&"
import script from "./time-ago.vue?vue&type=script&lang=js&"
export * from "./time-ago.vue?vue&type=script&lang=js&"
import style0 from "./time-ago.vue?vue&type=style&index=0&id=d92a1b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92a1b30",
  null
  
)

export default component.exports